import React from "react";
import Blog from "./pages/blog/Blog";
function App() {
  return (
    <>
      <Blog />
    </>
  );
}

export default App;
